import React from 'react';
import { Box } from '@mui/joy';
import { useFormatter } from '../../utils';

const CellPercentage = ({ value, type }) => {
    const { formatPercentage } = useFormatter();
    
    return (
        <Box className={"list-element-cell cell-" + type}>
            {(value !== undefined && value !== null && value !== '') 
                ? (() => {
                    const formatted = formatPercentage(value, true);
                    if (typeof formatted === 'number' && isNaN(formatted)) return '';
                    if (typeof formatted === 'string' && formatted.match(/NaN/)) return '';
                    return formatted;
                })()
                : ''}
        </Box>
    );
}

export default CellPercentage